/*
###################################################################
Fitinsur Open Insurance - Copyright 2019-2023 - All Rights Reserved
###################################################################
*/

/* eslint-disable react-hooks/rules-of-hooks */
/* eslint-disable no-unused-expressions */

function handleInitialAdjustments({
  questionnaire,
  setShowBrokerRemunerationDeductionSection,
}) {
  return questionnaire.map(question => {
    if (question.idQuestion === 175) {
      const showBrokerRemunerationDeductionSection = question?.idAnswerOption === 6893;
      setShowBrokerRemunerationDeductionSection(showBrokerRemunerationDeductionSection);
    }

    return question;
  })
};

async function handleQuestionChange({
  question,
  value,
  questionnaireUpdated,
  setQuestionnaireUpdated,
  setFieldValue,
  globalQuestionnaire,
  setShowBrokerRemunerationDeductionSection,
  brokerRemunerationDeductionGroup,
  setBrokerRemunerationDeductionGroup,
  questionnaireAnswersToDelete,
  setQuestionnaireAnswersToDelete,
}) {
  try {
    let saveQuestionnaire = false;

    if (question.idQuestion === 175) {
      if (!value?.idAnswerOption) return;

      const showBrokerRemunerationDeductionSection = value?.idAnswerOption && value?.idAnswerOption === 6893;
      setShowBrokerRemunerationDeductionSection(showBrokerRemunerationDeductionSection);

      let allQuestion = [];
      for (const group of brokerRemunerationDeductionGroup) {
        allQuestion = [...allQuestion, ...group]
          .map((question) => question.idQuestionnaireAnswers)
          .filter((idQuestionnaireAnswers) => idQuestionnaireAnswers);
      }

      setBrokerRemunerationDeductionGroup(
        brokerRemunerationDeductionGroup.map((group) => {
          group.map((question) => (question.behaviorObject.isRequired = showBrokerRemunerationDeductionSection));
          return group;
        })
      );

      if (!showBrokerRemunerationDeductionSection) {
        setQuestionnaireAnswersToDelete([...questionnaireAnswersToDelete, ...allQuestion]);
      } else {
        setQuestionnaireAnswersToDelete([
          ...questionnaireAnswersToDelete.filter((question) => !questionnaireAnswersToDelete.includes(question)),
        ]);
      }
    }

    if (saveQuestionnaire) setQuestionnaireUpdated(questionnaireUpdated);

  } catch (e) {
    console.log('BROKER_REMUNERATION_OTHER - handleQuestionChange - error', e)
  }
};

function handleQuestionBlur({
  question,
  value,
  setFieldValue,
  formikRef,
  obligorGroup,
  setObligorGroup,
  index,
  values,
  setMaxValuePerc,
  mask,
  maskPercentage,
}) {
  try {

  } catch (e) {
    console.log("BROKER_REMUNERATION_OTHER - handleQuestionBlur error", e)
  }
}

async function handleRequestSerproCnpj({
  question: rootQuestion,
  data,
  questionnaire,
  setQuestionnaire,
  setFieldValue,
}) {
  try {
    questionnaire = questionnaire.map(question => {

      return question;
    })

    setQuestionnaire(questionnaire);
  } catch (e) {
    console.log('BROKER_REMUNERATION_OTHER - handleRequestSerproCnpj - error', e)
  }
};

const events = {
  handleInitialAdjustments,
  handleQuestionChange,
  handleQuestionBlur,
  handleRequestSerproCnpj,
};

export { events };